import * as forge from 'node-forge';
import { Buffer } from 'buffer';
import { getSecureItem, removeSecureItem, setSecureItem } from './secureLocalStorage';
window.Buffer = Buffer;

// set the Tenant info from the local storage
export const setTenantInfo = (tenantInfo: any) => {
  tenantInfo = stringifyData(tenantInfo);
  localStorage.setItem("tenantInfo", tenantInfo);
};

// key for encoding and decoding text or objects 
export const encodedPassword = 'mQdL5zF=3Nb+g6Ax';

// set the app theme from the local storage
export const setAppThem = (appTheme: any) => {
  localStorage.setItem("appTheme", appTheme);
};

// get Tenant info
export const getTenantInfo = () => {
  const tenantInfo = parseIntoJSONData(localStorage.getItem("tenantInfo"));
  if (tenantInfo && tenantInfo !== "undefined") return tenantInfo;
  else return null;
};

// remove the Tenant info from the local storage
export const removeTenantInfo = () => {
  localStorage.removeItem("tenantInfo");
};

// get Tenant info
export const getIsADB2CLoginStatus = () => {
  // return true;
  const tenantInfo = parseIntoJSONData(localStorage.getItem("tenantInfo"));
  if (tenantInfo && tenantInfo !== "undefined") {
    return tenantInfo?.IsADB2CLogin || false;
  } else {
    return false;
  }
};

export const setTokenLS = (token: any) => {
  setSecureItem("token", token);
};

// get Tenant info
export const getTokenLS = () => {
  const token = getSecureItem("token");
  if (token && token !== "undefined") return token;
  else return null;
};

// remove the Tenant info from the local storage
export const removeTokenLS = () => {
  removeSecureItem("token");
};

// set the Tenant info from the local storage
export const setB2CAuthenticateSSOInfo = (b2cAuthSSOInfo: any) => {
  b2cAuthSSOInfo = stringifyData(b2cAuthSSOInfo);
  localStorage.setItem("b2cAuthSSOInfo", b2cAuthSSOInfo);
};

// get Tenant info
export const getB2CAuthenticateSSOInfo = () => {
  const b2cAuthSSOInfo = parseIntoJSONData(
    localStorage.getItem("b2cAuthSSOInfo")
  );
  if (b2cAuthSSOInfo && b2cAuthSSOInfo !== "undefined") return b2cAuthSSOInfo;
  else return null;
};

// remove the Tenant info from the local storage
export const removeB2CAuthenticateSSOInfo = () => {
  //localStorage.removeItem("b2cAuthSSOInfo");
};

// set the Tenant info from the local storage
export const setEnvInfo = (envData: any) => {
  envData = stringifyData(envData);
  localStorage.setItem("envData", envData);
};

// get Tenant info
export const getEnvInfo = () => {
  const envData = parseIntoJSONData(localStorage.getItem("envData"));
  if (envData && envData !== "undefined") return envData;
  else return null;
};

// remove the Tenant info from the local storage
export const removeEnvInfo = () => {
  sessionStorage.removeItem("envData");
};

// remove the Tenant info from the local storage
export const clearAllSessionStorage = () => {
  const envInfoObj = getEnvInfo();
  sessionStorage.clear();
  localStorage.removeItem('envData');
  setEnvInfo(envInfoObj);
};

export const clearAllSessionAndLocalStorage = () => {
  sessionStorage.clear();
  localStorage.clear();
};

export async function generateKey() {
  const key = await window.crypto.subtle.generateKey(
    {
      name: "AES-GCM",
      length: 256,
    },
    true,
    ["encrypt", "decrypt"]
  );
  return key;
}

export async function encryptObject(key: any, obj: any) {
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const encoder = new TextEncoder();
  const data = encoder.encode(JSON.stringify(obj));
  const encrypted = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    key,
    data
  );
  return { iv: iv, encryptedData: encrypted };
}

export async function decryptObject(key: any, encryptedObj: any) {
  const { iv, encryptedData } = encryptedObj;
  const decrypted = await window.crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    key,
    encryptedData
  );
  const decoder = new TextDecoder();
  const decryptedText = decoder.decode(decrypted);
  return JSON.parse(decryptedText);
}

export const stringifyData = (data: any) => {
  if (data && data !== null && data !== undefined) {
    return JSON.stringify(data);
  }
  return data;
};

export const parseIntoJSONData = (data: any) => {
  if (data && data !== null && data !== undefined && data !== "undefined") {
    return JSON.parse(data);
  }
  return data;
};

export const setCommittee = (conmmiteeInfo: any) => {
  const filteredData = conmmiteeInfo.map((item: any) => ({
    id: item.Id,
    name: item.Name,
  }));
  localStorage.setItem("committeeData", stringifyData(filteredData));
};

export const getCommittee = (tenantInfo: any) => {
  let committeData = parseIntoJSONData(localStorage.getItem("committeeData"));
  return committeData;
};

//Converting the window envirnment info into readable form
export const convertStringtoJson = (jsonString = '') => {
  try {
    const cleanString = jsonString
    ?.replace(/(\n|;)/g, '') // Remove newlines and semicolons
    ?.replace(/(\w+):/g, '$1:') // Add double quotes around keys
    ?.trim();
    const objKeysRegex = /({|,)(?:\s*)(?:')?([A-Za-z_$\.][A-Za-z0-9_ \-\.$]*)(?:')?(?:\s*):/g;// look for object names
    const newQuotedKeysString = cleanString?.replace(objKeysRegex, "$1\"$2\":");// all object names should be double quoted
    const newValue = newQuotedKeysString;
    return JSON.parse(newQuotedKeysString?.trim());

  } catch(e) {
    console.log('##########ee', e)
    return {};
  }
};


export function decryptedInfo(encryptedData: string): string {
  try {
    const encryptedBytes = forge.util.decode64(encryptedData);

    // Validate Salted__ header
    if (encryptedBytes.slice(0, 8) !== 'Salted__') {
      throw new Error('Missing OpenSSL salt header');
    }

    const salt = encryptedBytes.slice(8, 16);
    const ciphertext = encryptedBytes.slice(16);

    // Derive key + iv using PBKDF2 (OpenSSL default: 10000 iterations, SHA256)
    const keyIv = forge.pkcs5.pbkdf2(encodedPassword, salt, 10000, 48, forge.md.sha256.create());
    const key = keyIv.slice(0, 32);
    const iv = keyIv.slice(32, 48);

    // Create decipher
    const decipher = forge.cipher.createDecipher('AES-CBC', key);
    decipher.start({ iv });
    decipher.update(forge.util.createBuffer(ciphertext));
    const success = decipher.finish();

    if (!success) throw new Error('Decryption failed');
    const binaryOutput = decipher.output.getBytes();
    const byteArray = new Uint8Array(forge.util.createBuffer(binaryOutput).toHex().match(/.{1,2}/g)!.map(b => parseInt(b, 16)));

    const decoder = new TextDecoder('utf-8');
    const decryptedText = decoder.decode(byteArray);
    return decryptedText;
  } catch (err) {
    console.error('Decryption error:', err);
    return '';
  }
}
export const setObjIntoWindow = async (finalJSON = {}) => {
  if(finalJSON) {
    setEnvInfo(finalJSON);
  }
};


export const setIdToken = (token: any) => {
  localStorage.setItem("idToken", token);
};

export const expireTokenTime = (dateTim: any) => {
  localStorage.setItem("expiresOn", dateTim);
};

export const setRedirectPath = (path: any) => {
  const committeeDetailsRegex = /^\/(committee\/details|member\/request-view)\/[a-f0-9\-]{36}$/i;
 // if (committeeDetailsRegex.test(path)) {
   const excludePath = ['/signin-oidc','/', '/error', '/subscription-expired', '/access-denied','/viewLogs'];
   //do not store localstoare while oute is excluded path
   if (!excludePath.includes(path)) {
     localStorage.setItem("redirectPath", path);
   }
 // }
};


export const isStaffRoute = (path: any) => {
  const staffRoutes = ['/standard',"/standard/details", '/all-membership',"/record/standard","/report/pending-reappointments","/report/bi-report","/report/record-status","/report/member-data-survey-report","/report/request-report","/report/committee-report","/report/balance-interest","/report/balance-interest","/report/committee-member-report","/record/non-standard","","record/administrative","/volunteers","/ballot/standard","/ballot/membership","/ballot/standard","/ballot/non-standard-documents","/ballot/administrative","/committee/create","/standard/create","/positions/add-position","/record/standard/create","/record/administrative/create","/record/non-standard/create","/ballot/membership/create","/ballot/standard/create"];
  return staffRoutes.includes(path);
};

export const isMemberRestrictedRoute = (path: any) => {
  // Check for specific route patterns that should be restricted for members
  const restrictedPatterns = [
    '/standard/details/'
  ];
  return restrictedPatterns.some(pattern => path.startsWith(pattern));
};

